export default "__VITE_ASSET__d35299f7__"